import { androidMock } from '../hostAppInterface/android';
import { iosMock } from '../hostAppInterface/ios';
import { selfserveMock } from '../hostAppInterface/selfserve';
import { webMock } from '../hostAppInterface/web';
import { viewportConfigs } from './constants';
import { type Platform } from './types';

export function initializePlatformMock(mockPlatform: Platform): void {
  if (process.env.NODE_ENV === 'development') {
    // Only set mock data if it's a valid platform
    if (mockPlatform && viewportConfigs[mockPlatform]) {
      window.hostApp = {
        platform: mockPlatform,
        ...(mockPlatform === 'android' && androidMock),
        ...(mockPlatform === 'ios' && iosMock),
        ...(mockPlatform === 'selfserve' && selfserveMock),
        ...(mockPlatform === 'web' && webMock),
      };
      window.isWebPlatform = false;
    }
  }
}
